import type { ReactNode } from 'react'

import styles from './StateMessage.module.css'

export function EmptyState({ children }: { children: ReactNode }) {
  return <div className={styles.state}>{children}</div>
}

export function ErrorState({ children }: { children: ReactNode }) {
  return (
    <div className={`${styles.state} ${styles.error}`} role="alert">
      {children}
    </div>
  )
}

export function Skeleton({ label, tall }: { label: string; tall?: boolean }) {
  return (
    <div className={`${styles.skeleton} ${tall ? styles.tall : ''}`} role="status" aria-live="polite">
      <span className="visually-hidden">{label}</span>
    </div>
  )
}
